import { green } from 'bold-ui/lib/styles/colors'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { SoapSection } from '../SoapSection'
import { PlanoForm, PlanoFormModel } from './PlanoForm'

export interface PlanoSectionProps {
  cidadao: CidadaoAtendimento
  prontuarioId: ID
  name: MetaPath<PlanoFormModel>
  tipoAtendProf: TipoAtendimentoProfissional
  isAtendimentoOdonto?: boolean
  atendimentoId: ID
  dataAtendimento: Instant
}

export function PlanoSection(props: PlanoSectionProps) {
  return (
    <SoapSection initial='P' title='Plano' color={green}>
      <PlanoForm {...props} />
    </SoapSection>
  )
}
